import React from 'react'
import MediaQuery from 'react-responsive'

import styled from 'styled-components'

import theme from 'theme'
import { SIDEBAR_NAV_CONTAINER } from 'utils/testing/testIDs'

import BottomBar from './components/BottomBar'
import { SideBar } from './components/SideBar'
import { useShowSideNav } from './hooks'

const NavContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${(props) => props.theme.colors.white};
  @media screen and (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    flex-direction: column;
  }
`

type NavWrapperProps = {
  children?: React.ReactNode
}

const NavigationWrapper = (childPage: NavWrapperProps) => {
  const { showNavOnThisRoute } = useShowSideNav()

  return (
    <NavContainer data-testid={SIDEBAR_NAV_CONTAINER}>
      {showNavOnThisRoute ? (
        <>
          <MediaQuery minWidth={theme.breakpoints.sm + 1}>
            <SideBar />
            {childPage.children}
          </MediaQuery>
          <MediaQuery maxWidth={theme.breakpoints.sm}>
            {childPage.children}
            <BottomBar />
          </MediaQuery>
        </>
      ) : (
        <>{childPage.children}</>
      )}
    </NavContainer>
  )
}

export default NavigationWrapper
